import { getABTProvider } from '@/plugins/abt/statsig'

export const GATE_TEMP_TRANSACTION_POST_MIGRATION_ENABLED =
  'gate_temp_transaction_post_migration_enabled'

export function isTransactionPostMigrationEnabled() {
  return getABTProvider().isFeatureEnabled(
    GATE_TEMP_TRANSACTION_POST_MIGRATION_ENABLED
  )
}
